export default __webpack_public_path__ + "static/media/Garaz2.9bdb5730.jpeg";